import React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { Typography } from "@mui/material";

export default function AdminChangeUserInfoButton(props) {
  // 変更があるかどうかの判定を定数化
  const hasChanged =
    props.data.name !== props.nameCheck ||
    props.data.email2 !== props.email2Check ||
    props.data.admin_flag !== props.userClass ||
    props.data.notification_flag !== props.mailNotification;

  return (
    <Box textAlign="center">
      <Button
        type="submit"
        variant="contained"
        disabled={!hasChanged}
        sx={{
          marginTop: "30px",
          borderRadius: "25px",
          color: "white",
          fontSize: "14px",
          fontWeight: "bold",
          backgroundColor: hasChanged ? "#28345e" : "#B2B2B2",
          width: "180px",
          "&:hover": {
            background: hasChanged ? "#8bb6c6" : "#B2B2B2",
          },
          "&.Mui-disabled": {
            color: "white",
            backgroundColor: "#B2B2B2",
          },
        }}
      >
        <Typography
          sx={{
            fontSize: 14,
            marginTop: "10px",
            marginBottom: "10px",
            fontWeight: "bold",
          }}
        >
          保存
        </Typography>
      </Button>
    </Box>
  );
}